import { initialUnitCompanionLogServicingState } from './initialState';

import {
  UNITCOMPANIONLOGSERVICING_ERROR,
  UNITCOMPANIONLOGSERVICING_IS_LOADING,
  GET_ALL_UNITCOMPANIONLOGSERVICING_SESSIONS,
  SET_UNITCOMPANIONLOGSERVICING_CURRENT_PAGE,
  SET_UNITCOMPANIONLOGSERVICING_SESSION,
  SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_LOADING,
  SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_DETAIL,
  UNITCOMPANIONLOGSERVICING_CLEANUP
} from '../constants/index';

const unitCompanionLogServicingReducer = (state = initialUnitCompanionLogServicingState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_ALL_UNITCOMPANIONLOGSERVICING_SESSIONS: {
      const { data } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          ...data
        }
      };
    }

    case SET_UNITCOMPANIONLOGSERVICING_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          currentPage
        }
      };
    }

    case UNITCOMPANIONLOGSERVICING_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          isLoading
        }
      };
    }

    case UNITCOMPANIONLOGSERVICING_ERROR: {
      const { data } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          ...data
        }
      };
    }

    case SET_UNITCOMPANIONLOGSERVICING_SESSION: {
      const { selectedSession, procedures } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          isOpSuccessful: false,
          showBanner: false,
          selectedSession: {
            ...state.unitCompanionLogServicing.selectedSession,
            ...selectedSession
          },
          procedures: procedures || [],
          // Fresh session, fresh expand state - a stale procedure's actions/
          // photos from whatever session was viewed previously must not
          // carry over.
          procedureDetails: {}
        }
      };
    }

    case SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_LOADING: {
      const { guidedServiceProcedureId } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          loadingProcedureId: guidedServiceProcedureId
        }
      };
    }

    case SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_DETAIL: {
      const { guidedServiceProcedureId, actions, photos } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          loadingProcedureId: null,
          procedureDetails: {
            ...state.unitCompanionLogServicing.procedureDetails,
            [guidedServiceProcedureId]: { actions, photos }
          }
        }
      };
    }

    case UNITCOMPANIONLOGSERVICING_CLEANUP: {
      const { unitCompanionLogServicing } = payload;
      return {
        ...state,
        unitCompanionLogServicing: {
          ...state.unitCompanionLogServicing,
          ...unitCompanionLogServicing
        }
      };
    }

    default:
      return state;
  }
};

export default unitCompanionLogServicingReducer;
